/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  Button,
  Collapse,
  Grid,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import { TitleDivider } from '@stack/ui/components';
import startCase from 'lodash/startCase';
import upperFirst from 'lodash/upperFirst';

import { Props } from './props';

export const SpecificationContainer: React.FC<Props> = (props) => {
  const { data } = props;
  const [expanded, setExpanded] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  const renderItem = (title: string, value: string) => {
    return (
      <Grid key={title} item xs={12} md={6}>
        <Stack
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          borderBottom={'1px solid #EDECED'}
          pb={2}
        >
          <Typography
            fontSize={14}
            minWidth={'160px'}
            maxWidth={'35%'}
            textTransform={'capitalize'}
          >
            {title}
          </Typography>
          <Typography
            fontSize={14}
            fontWeight={500}
            maxWidth={'65%'}
            // sx={{
            //   display: '-webkit-box',
            //   flexWrap: 'nowrap',
            //   '-webkit-line-clamp': '2',
            //   '-webkit-box-orient': 'vertical',
            //   overflow: 'hidden',
            //   textOverflow: 'ellipsis'
            // }}
          >
            {value || '-'}
          </Typography>
        </Stack>
      </Grid>
    );
  };

  const selectedData = Object.entries(data ?? {})?.[selectedTab]?.[1];
  const ShowMoreIcon = expanded ? KeyboardArrowUpIcon : KeyboardArrowDownIcon;

  return (
    <TitleDivider title={'Specifications & Equipments'}>
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        TabIndicatorProps={{ style: { background: '#FFC800' } }}
      >
        {Object.entries(data ?? {}).map(([key]) => (
          <Tab
            sx={{
              fontSize: 16,
              fontWeight: 700,
              textTransform: 'capitalize',
              color: '#1E242F !important',
              p: '0px 8px 12px 8px',
            }}
            key={key}
            label={upperFirst(key)}
          />
        ))}
      </Tabs>
      <Stack position={'relative'} border={'1px solid #EDECED'}>
        <Stack
          sx={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            background: expanded
              ? 'transparent'
              : 'linear-gradient(transparent,white)',
            justifyContent: 'flex-end',
          }}
        />

        <Collapse in={expanded} collapsedSize={350}>
          <Stack gap={5} p={5}>
            {Object.entries(selectedData ?? {}).map(([key, value]) => (
              <Stack key={key} gap={2.5}>
                <Typography fontSize={16} fontWeight={700}>
                  {startCase(key.toLowerCase())}
                </Typography>
                <Grid container columnSpacing={12.5} rowSpacing={2}>
                  {Object.entries(value).map(([key, itemValue]: any) => {
                    return renderItem(
                      key,
                      itemValue?.[0]?.car_variant_spec_value
                    );
                  })}
                </Grid>
              </Stack>
            ))}
          </Stack>
        </Collapse>
        <Stack p={5} bgcolor={'white'} zIndex={100} width={'100%'}>
          <Typography fontSize={14}>
            *Actual specifications for this vehicle may differ, please confirm
            with the seller.
          </Typography>
        </Stack>
      </Stack>
      <Button
        fullWidth
        variant="text"
        color="info"
        sx={{
          bgcolor: 'white',
          border: '1px solid #EDECED',
          borderTop: '0px !important',
          py: 2,
          fontSize: 16,
          borderRadius: 0,
          fontWeight: 700,
          ':hover': {
            backgroundColor: '#F7F7F7 !important',
          },
        }}
        endIcon={
          <ShowMoreIcon sx={{ color: 'text.primary', marginLeft: -1 }} />
        }
        onClick={handleExpandClick}
      >
        {`Show ${expanded ? 'Less' : 'More'}`}
      </Button>
    </TitleDivider>
  );
};

export default SpecificationContainer;
